import { assert, enums, object } from 'superstruct'
import { belts } from '~/mixins/belts'
import { all as allAgeDivisions } from '~/mixins/ageDivisions'
import { all as allWeightDivisions } from '~/mixins/weightDivisions'
import { all as allGenders } from '~/mixins/genders'

/**
 * Esse Value Object é útil para representar uma categoria como uma string,
 * garantindo que cada parte seja válida. Ex: 'adult|male|blue|light'
 */
export class CategoryKey {
  static SEPARATOR = '|'
  static FORMAT = 'age_division|gender|belt|weight_division'
  static AGE_DIVISIONS = allAgeDivisions().map(d => d.name)
  static GENDERS = allGenders().map(g => g.name)
  static BELTS = belts().map(b => b.name)
  static WEIGHT_DIVISIONS = allWeightDivisions().map(d => d.name)

  static parse(value) {
    const parts = String(value ?? '').split(this.SEPARATOR)

    if (parts.length !== 4) {
      throw new Error(`must follow format '${this.FORMAT}', got '${value}'`)
    }

    const [ageDivision, gender, belt, weightDivision] = parts

    return new CategoryKey({ ageDivision, gender, belt, weightDivision })
  }

  constructor({ ageDivision, gender, belt, weightDivision }) {
    assert(
      { ageDivision, gender, belt, weightDivision },
      object({
        ageDivision: enums(CategoryKey.AGE_DIVISIONS),
        gender: enums(CategoryKey.GENDERS),
        belt: enums(CategoryKey.BELTS),
        weightDivision: enums(CategoryKey.WEIGHT_DIVISIONS)
      })
    )

    this.ageDivision = ageDivision
    this.gender = gender
    this.belt = belt
    this.weightDivision = weightDivision
  }

  toString() {
    return [this.ageDivision, this.gender, this.belt, this.weightDivision].join(
      CategoryKey.SEPARATOR
    )
  }
}
